import { TypeFile } from 'practice/components/detail/form/accordion-attachments/form';
import { DataWizardAct, DocumentVM } from 'civil-status/view-models/step-form';
import { ID_TIPO_ALLEGATO_DESCRIZIONE_MANUALE } from 'civil-status/components/step/form/last-step/accordions/document/form/form-data';
import { TYPE_DOCUMENT_PROCESSO_VERBALE } from 'civil-status/constants/type-document-processo-verbale';

export const transformDocument = (data: DataWizardAct): DocumentVM | undefined => {
  const castedResponseAllegati = data?.allegatoList || [];
  const filterAllegati = castedResponseAllegati?.filter(
    (item) => item.tipoAllegato !== TYPE_DOCUMENT_PROCESSO_VERBALE
  );

  if (filterAllegati?.length === 0) {
    return {
      isSaved: false,
    };
  }

  const withDescription = filterAllegati.find(
    (item) => item.tipoAllegato === ID_TIPO_ALLEGATO_DESCRIZIONE_MANUALE
  );

  let descriptions: Record<string, string> = {};

  if (withDescription) {
    filterAllegati.forEach((item) => {
      const key = `description-${item.tipoAllegato}-${item.nomeFile}`;

      descriptions = {
        ...(descriptions || {}),
        [key]: item.descrizioneTipoAllegato || '',
      };
    });
  }

  const document: DocumentVM = {
    files: filterAllegati.map(
      (item) =>
        ({
          tipoAllegato: item.tipoAllegato || '',
          name: item.nomeFile || '',
          idAllegato: item.key?.idAllegato || undefined,
          raw: item.oggettoAllegato || '',
          codStato: item.codStato || '',
        } as TypeFile)
    ),
    descriptions,
    obligatoryFiles: [],
    isSaved: true,
  };

  return document;
};
